import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

interface AlertModalProps {
	triggerComponent?: React.ReactNode;
	title: string | React.ReactNode;
	desc?: string | React.ReactNode;
	confirmText?: string;
	confirmFunction?: () => void;
}

export default function AlertModal({
	triggerComponent,
	title,
	desc,
	confirmText,
	confirmFunction,
}: AlertModalProps) {
	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				{triggerComponent || <Button variant="outline">Show Dialog</Button>}
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>{title}</AlertDialogTitle>
					<AlertDialogDescription>{desc}</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>ຍົກເລີກ</AlertDialogCancel>
					<AlertDialogAction asChild>
						<Button
							type="button"
							variant={"destructive"}
							onClick={confirmFunction}
							className="bg-[#FF0707] hover:bg-[#FF0707]/80"
						>
							{confirmText || "ຕົກລົງ"}
						</Button>
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
